<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * MONEY OBJECT
 *
 * This module handles money data types.
 *
 * @package ValueObjects
 */

import MoneyFormat from 'vue-money-format'

const rates = {}
let fxRates = null

// const OFX = 'cd82cbc2ae3a4c2b829b1bcc1aeca51b'
let defaultCurrency = 'USD'

export default {
  name: 'v-money',
  alias: 'money',
  components: { MoneyFormat },

  props: {
    value    : { type: Number, default: 0 },
    currency : { type: String },
    code     : { type: Boolean },
    supplementalPrecision: { type: Number, default: 0 },
    locale   : { type: String, default: 'en' },
    skipConversion : { type: Boolean, default: true }
  },

  computed: {
    symbol() {
      return this.getSymbol()
    },
    _currency() {
      const context = document.querySelector('.module') && document.querySelector('.module').__vue__ || {}
      const parent = this.$parent || {}

      return this.currency || parent.currency || context.currency || defaultCurrency
    }
  },

  data() {
    return {
      parsedValue : 0,
      negative    : false,
      nil         : false,
      _locale     : null,
      formatted   : '',
      rates       : {}
    }
  },

  beforeCreate() {
    /* if (!fxRates) {
      fxRates = this.api.g.get(`https://openexchangerates.org/api/latest.json?app_id=${OFX}`)
        .then(r => {
          fxRates = r.data.rates
          // this.parsedValue = this.parse()
          // setTimeout(this.render)
        })
      //
    } */
    // fxRates = fxRates || this.api.g.get(`https://openexchangerates.org/api/latest.json?app_id=${OFX}`)
    fxRates = {}
  },

  created() {
    fxRates.then && fxRates.then(r => {
      fxRates = r.data.rates
      this.render()
    })
  },

  mounted() {
    this.parsedValue = this.parse()
    // this.render()
  },

  updated() {
    this.render()
  },

  methods: {
    parse() {
      let value = this.$el.querySelector('.value').innerText || this.value
      let rate  = fxRates[this._currency] || rates[this._currency] || 1
      let absValue = null

      value = +value * (this.skipConversion ? 1 : rate)

      this.negative = value < 0
      this.nil = value === 0

      absValue = Math.abs(value)

      // multipliers
      /* if (Math.abs(value) > 1000000) {
        absValue = absValue / 1000000
        this.multiplier = 'M'
      }
      if (Math.abs(value) > 1000000000) {
        absValue = absValue / 1000000
        this.multiplier = 'B'
      } */

      return absValue
    },

    getRate(currency, skip) {
      const _currency = currency || this._currency
      const _skip = skip || this.skipConversion

      return _skip ? 1 : fxRates[_currency] || rates[_currency] || 1
    },

    getSymbol() {
      return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this._currency })
        .format(0)
        .replace('.00', '')
        .replace(',00', '')
        .replace('0', '')
        .trim()
    },

    render() {
      const el = this.$el.querySelector('.money')

      const SYM            = this.symbol
      const NEGATIVE_FIRST = `${SYM}(`
      const NEGATIVE_LAST  = `) ${SYM}`
      const symbolFirst    = !isNaN(el.innerText.trim().substr(-1))

      this.parsedValue = this.parse()

      if (this.negative) {
        this.formatted =
          (symbolFirst ? '' : '(') +
          el.innerHTML
            .replace(SYM, symbolFirst ? NEGATIVE_FIRST : NEGATIVE_LAST)
            .replace(/&nbsp;/g, '')
            .trim() +
          (symbolFirst ? ')' : '')
      } else {
        let value = this.parsedValue ? el.innerHTML.replace(/&nbsp;/g, '') : el.innerText
        this.formatted = SYM.length > 2
                          ? value.replace(SYM, !symbolFirst ? `${SYM} ` : ` ${SYM}`)
                          : value
        // this.formatted = el.innerHTML.replace(/&nbsp;/g, '')
      }
    }
  }
}

</script>

<template lang="pug">
span.money(:title='formatted', :class='{ negative: negative, nil: nil, lazy: $root.loading }')
  span.value
    slot
  money-format.money(
    :value='parsedValue'
    :locale='locale'
    :currency-code='_currency'
    :subunits-value='false'
    :hide-subunits='false'
    :supplemental-precision='supplementalPrecision'
  )
  span.formatted {{formatted}}
</template>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.money {
  display: inline;
  &.negative {
    @include theme {
    color: v(urgent-02);
    }
  }
  &.nil {
    opacity: .3;
  }
  &.nil.solid {
    opacity: 1;
  }
  .ag-custom-cell-value &.nil {
    opacity: .7;
  }

  &.lazy {
    @include theme() { background: v(background-light) }
    color: transparent;
    border-radius: 3px;
  }

  .money {
    display: none;
  }

  .value {
    display: none;
  }

  .formatted {
    display: inline;
  }
}

</style>



// WEBPACK FOOTER //
// src/core/value-objects/money/index.vue